<template>
    <InfoLayout2 :nextPage="nextPage">
        <template #header-title>          
            <div :class="{accent: lastChance && !finished}" style="height: 85px;">
                <template v-if="finished">
                    <h6 v-if="shouldLose">No risk if you Lose</h6>
                    <h6 v-else>Your Ticket to the Ultimate G.O.A.T</h6>
                </template>

                <template v-else>
                    <div class="clock">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="11.9999" cy="12.8203" r="8.25" stroke="white" stroke-width="1.5"/>
                        <path d="M10.5 1.5H12.0003M13.5 1.5H12.0003M12.0003 1.5V4" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                        <path d="M18.7677 4L19.8286 5.06088M20.889 6.12132L19.8286 5.06088M19.8286 5.06088L18.0608 6.82865" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                        <path d="M12 8.99805V12.9107L15 14.998" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <p class="small">Voting ends in</p>
                    <h6>{{timer}}</h6>
                </template>
            </div>  
        </template>

        <template #main>
            <VoteBox 
                :selectable=selectable 
                :preSelectedIndex="selectedIndex"
                @selected="handleSelection"
                :choices="[
                    {
                        version: 'A',
                        image: require('@/assets/imgs/goat-nft-1.jpg'),
                        overlay: overlay0
                    },
                    {
                        version: 'B',
                        image: require('@/assets/imgs/goat-nft-2.jpg'),
                        overlay: overlay1
                    }
                ]"
                >

            </VoteBox>
            
            <template v-if="finished">
                <br>
                <InfoBox v-if="shouldLose" class="lose-info">
                    <p>If the Alpha G.O.A.T you voted for doesn’t make it, don’t worry—your <span class="title small">voting fee</span> will be <span class="title small">fully refunded</span>. It's all about fairness, and we’ve got your back!</p>
                </InfoBox>
                <InfoBox v-else class="win-info">
                    <p>If your Alpha G.O.A.T takes the crown, you’ll <span class="title small">get the chance to make it yours</span>!</p>
                </InfoBox>
            </template>
            <template v-else>
                <br>
                <div v-if="lastChance">
                    <p class="title large accent">Last chance to vote!</p>
                    <br>
                    <InfoBox class="icon-override">
                        <p>This is just a <span class="title small">simulated round</span>, and we're holding on for your decision.</p>
                        <br>
                        <p>In the <span class="title small">actual round</span>, however, <span class="title small">things move fast</span>, and you might miss out if you hesitate. Don’t miss your opportunity to make an impact!</p>
                    </InfoBox>
                </div>
                <div v-else-if="!selected">
                    <img class="clamp-height" style="height: 40px;" src="data:image/svg+xml;base64,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" alt="Touch icon">            
                    <p style="padding: 10px 40px;">Choose the Alpha G.O.A.T that speaks to you—just tap to cast your vote!</p>
                </div>
            </template>
        </template>
    </InfoLayout2>
</template>

<script>
const INITIAL_TIMER = 120;
const LAST_CHANCE_THRESHOLD = 5;

export default {    
    inject: ['goToPage'],
    mounted() {
        const instance = this;
        this.interval = setInterval(() => {
            if (instance.remaining > 0) {
                instance.remaining -= 1;                
            }

            if (instance.remaining <= LAST_CHANCE_THRESHOLD) {
                clearInterval(instance.interval);
                instance.interval = null;
            }
        }, 1000);
    },
    unmounted() {
        if(this.interval) {
            clearInterval(this.interval);
        }
    },
    props: { shouldLose: {type: Boolean, default: true} },
    methods: {
        handleSelection(index) {
            
            this.selectedIndex = index;
            this.selectable = false;
            if(this.interval) {
                clearInterval(this.interval);
            }
            
            if(this.remaining > 0) {
                const instance = this;
                const rate = .1;
                const step = Math.ceil(rate * (instance.remaining / 2));
                this.interval = setInterval(() => {
                    if (instance.remaining > 0) {
                        instance.remaining = Math.max(instance.remaining - step, 0);                        
                    } else {
                        clearInterval(instance.interval);
                        instance.interval = null;
                    }
                }, rate * 1000);
            }
        }
    },
    computed: {
        timer() {
            const m = Math.floor(this.remaining / 60);
            const s = Math.floor(this.remaining % 60);

            return `${m<10?'0':''}${m}:${s<10?'0':''}${s}`;
        },
        lastChance() { return !this.selected && this.remaining <= LAST_CHANCE_THRESHOLD; },
        finished() { return this.remaining <= 0; },
        selected() { return this.selectedIndex >= 0; },
        winnerOverlay() { return { votes: this.winVotes, winner: this.finished } },
        loserOverlay() { return { votes: this.loseVotes, loser: this.finished } },        

        overlay0() { 
            if(!this.selected) { 
                return null; 
            }

            return (this.selectedIndex == 0) == this.shouldLose ? this.loserOverlay : this.winnerOverlay;
        },

        overlay1() { 
            if(!this.selected) { 
                return null; 
            }

            return (this.selectedIndex == 1) == this.shouldLose ? this.loserOverlay : this.winnerOverlay;
        },

        nextPage() {
            if(!this.finished) {
                return null;
            }

            return this.shouldLose ?
                        {buttonTitle: 'Let’s See the Outcome', id: 'GemMechanism10Lose'} :
                        {buttonTitle: 'Tell me How!', id: 'GemMechanism10Win'};
        },
    },
    data() {
        return {
            remaining: INITIAL_TIMER,
            selectable: true,
            selectedIndex: -1,
            loseVotes: Math.floor(Math.random() * 50) + 100,
            winVotes: Math.floor(Math.random() * 50) + 160,
        };
    }
};
</script>

<style lang="scss" scoped>

.clock {
    width: 24px;    
    height: 24px; 
    margin-top: -12px;
    margin-inline: auto;
    
    svg path, svg circle {
        stroke: var(--tint, var(--color-surface));
    }
}

.accent {
    --tint: var(--color-accent);
    color: var(--color-accent);
}

.icon-override {
    --icon-img: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxLjYxODcgMTRMMjEuMzU1NCAyMy42Nzk4SDE4Ljg4NDlMMTguNjE0OCAxNEgyMS42MTg3Wk0yMC4xMjAyIDI4QzE5LjY3NDYgMjggMTkuMjkyMSAyNy44NDI1IDE4Ljk3MjYgMjcuNTI3NUMxOC42NTMxIDI3LjIwOCAxOC40OTU2IDI2LjgyNTUgMTguNTAwMSAyNi4zNzk5QzE4LjQ5NTYgMjUuOTM4OSAxOC42NTMxIDI1LjU2MDkgMTguOTcyNiAyNS4yNDU5QzE5LjI5MjEgMjQuOTMwOSAxOS42NzQ2IDI0Ljc3MzQgMjAuMTIwMiAyNC43NzM0QzIwLjU0NzcgMjQuNzczNCAyMC45MjM0IDI0LjkzMDkgMjEuMjQ3NCAyNS4yNDU5QzIxLjU3MTUgMjUuNTYwOSAyMS43MzU3IDI1LjkzODkgMjEuNzQwMiAyNi4zNzk5QzIxLjczNTcgMjYuNjc3IDIxLjY1NyAyNi45NDkyIDIxLjUwNCAyNy4xOTY3QzIxLjM1NTQgMjcuNDM5NyAyMS4xNTk3IDI3LjYzNTUgMjAuOTE2NyAyNy43ODRDMjAuNjczNyAyNy45MjggMjAuNDA4MiAyOCAyMC4xMjAyIDI4WiIgZmlsbD0iI0JGQkZCRiIvPgo8cGF0aCBkPSJNMTcuMTk2MiA4Ljc2NTk0QzE4LjQ1MTggNi42MjQwNSAyMS41NDgyIDYuNjI0MDUgMjIuODAzOCA4Ljc2NTkzTDMyLjgyMjMgMjUuODU2NEMzNC4wOTI0IDI4LjAyMyAzMi41MyAzMC43NSAzMC4wMTg2IDMwLjc1SDkuOTgxNDVDNy40NzAwMyAzMC43NSA1LjkwNzYgMjguMDIzIDcuMTc3NjggMjUuODU2NEwxNy4xOTYyIDguNzY1OTRaIiBzdHJva2U9IiNEOUQ5RDkiIHN0cm9rZS13aWR0aD0iMS41Ii8+Cjwvc3ZnPgo=");
}

.lose-info {
    --icon-img: url("data:image/svg+xml;base64,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");
}

.win-info {
    --icon-img: url("data:image/svg+xml;base64,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");
}

</style>